// extracted by mini-css-extract-plugin
export default {"trStyle":"UserList_trStyle__-SfnI","btnStyle":"UserList_btnStyle__fAnYt"};